module.exports = __webpack_public_path__ + "img/bottom_building_001.8ffac98e.svg";